<template>
  <fullscreen-overlay-frame :title="$t('smart-charging-onboarding-dialog.title').toString()"
                            icon="ev_station"
                            color="primary"
                            centered
                            closable
                            maximizable
                            @close="close"
                            @maximize="maximize"
                            @minimize="minimize">
    <template v-slot:content>
      <div v-html="$t('smart-charging-onboarding-dialog.description')"/>
      <charge-locations-list :vehicle-id="data.vehicleId"/>
      <v-card class="my-4">
        <v-card-title>
          {{ $t('smart-charging-onboarding-dialog.smart-charging.card-title') }}
        </v-card-title>
        <v-card-text class="pa-2">
          <v-expansion-panels flat color="background" v-model="expansionPanels">
            <v-expansion-panel :key="0" readonly>
              <v-expansion-panel-header class="pa-3" disable-icon-rotate>
                <div v-show="expansionPanels === null">
                  <v-icon color="primary" class="mr-2">
                    outlined_flag
                  </v-icon>
                  {{
                    $t('smart-charging-onboarding-dialog.summary.deadline', {deadline: smartChargingPolicy.deadline})
                  }}
                </div>
                <div v-show="expansionPanels !== null">
                  <v-icon color="primary">
                    outlined_flag
                  </v-icon>
                  {{ $t('smart-charging-onboarding-dialog.smart-charging-policy.title') }}
                </div>
                <template v-slot:actions>
                  <v-icon color="primary" @click="toggleEdit">
                    edit
                  </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-form>
                  <v-dialog
                      ref="dialog"
                      v-model="timePickerMenu"
                      :return-value.sync="smartChargingPolicy.deadline"
                      persistent
                      width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          outlined
                          v-model="smartChargingPolicy.deadline"
                          :label="$t('smart-charging-onboarding-dialog.deadline.text-field-label')"
                          readonly
                          required
                          :rules="rules"
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                        v-if="timePickerMenu"
                        v-model="smartChargingPolicy.deadline"
                        full-width
                        format="24hr"
                        @click:minute="$refs.dialog.save(smartChargingPolicy.deadline); timePickerMenu = false"
                    >
                    </v-time-picker>
                  </v-dialog>
                  <v-btn block :loading="saving" color="primary" @click="updateSmartChargingPolicy">
                    {{ $t('app.save') }}
                  </v-btn>
                </v-form>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <smart-charging-plan :vehicle-id="data.vehicleId"/>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </template>
  </fullscreen-overlay-frame>
</template>

<script>
import FullscreenOverlayFrame from "@/templates/dialogs/FullscreenOverlayFrame.vue";
import ChargeLocationsList from "@/templates/components/ChargeLocationList.vue";
import SmartChargingPlan from "@/templates/components/emobility/SmartChargingPlan.vue";

export default {
  name: "SmartChargingOnboardingDialog",
  components: {SmartChargingPlan, ChargeLocationsList, FullscreenOverlayFrame},
  props: ['data'],
  data() {
    return {
      smartChargingPolicy: {
        minimumChargeLimit: 0,
        deadline: "",
        isEnabled: false,
      },
      rules: [
        v => !!v || "$t('app.rules.required')"
      ],
      // Must not be empty and between 0 and 100
      minimumChargeLimitRules: [
        v => v >= 0 && v <= 100 || this.$t('smart-charging-onboarding-dialog.minimumChargeLimit.range'),
        v => !!v || this.$t('app.rules.required')
      ],
      fullscreen: false,
      timePickerMenu: false,
      expansionPanels: null,
      saving: false,
    }
  },
  methods: {
    fetchSmartChargingPolicy() {
      this.$rhRequest.sendGet(
          {
            endpoint: "enode/get-smart-charging-policy?id=" + this.data?.vehicleId
          }, (response) => {
            this.smartChargingPolicy = response?.data?.data
          }, (error) => {
            console.error(error);
          })
    },
    updateSmartChargingPolicy() {
      this.saving = true
      this.smartChargingPolicy.minimumChargeLimit = 0
      this.$rhRequest.sendPut({
        endpoint: "enode/update-smart-charging-policy?id=" + this.data?.vehicleId,
        data: this.smartChargingPolicy
      }, (response) => {
        this.smartChargingPolicy = response?.data?.data
        this.saving = false
        this.$root.bisatoast.success({
          message: this.$t('smart-charging-onboarding-dialog.smart-charging-policy-update.success'),
          showCloseBtn: true
        })
        this.expansionPanels = null
      }, (error) => {
        console.error(error)
        this.saving = false
        this.$root.bisatoast.error({
          message: this.$t('app.generic-error'),
          showCloseBtn: true
        })
      })
    },
    toggleEdit() {
      if (this.expansionPanels === 0) {
        this.expansionPanels = null
      } else {
        this.expansionPanels = 0
      }
    },
    /**
     * maximize dialog
     */
    maximize() {
      this.fullscreen = true
      this.$emit('maximize')
    },

    /**
     * minimize dialog
     */
    minimize() {
      this.fullscreen = false
      this.$emit('minimize')
    },
    /**
     * close dialog
     */
    close() {
      this.$root.bisadialog.toggle('smartChargingOnboarding', false)
      this.$root.$emit('updateSmartCharging')
    },
  },
  mounted() {
    this.fetchSmartChargingPolicy()
  }
}
</script>

<style scoped lang="scss">

</style>